import React, { Component } from "react";

export default class Projects extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">Projects</span>
                <h2 className="colorlib-heading animate-box">Projects</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Ez-Shopper
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Angular6, Firebase, GitHub</h5>
                          <h5>Description: <ul>
                            <li> Ez-Shopper is E-Commerce Website Across-needs is an Online-cart system where
                              users can buy products and sellers can add their products to sell online.</li>
                            <li> Role – Full Stack Developer</li>
                            <li> URL - https://ez-shopper-dev.firebaseapp.com</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Cupid Ecommerce Store
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Python, Django, HTML, CSS3, Bootstrap, PostgreSQL, GitHub</h5>
                          <h5>Description: <ul>
                            <li> ❏Cupid_ecommerce_store is an Online-Ecommerce system where users can
                              Authentication, buy products, Payment System.</li>
                            <li> Role – Full Stack Developer</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          M3U Editor
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Python, Django, Ajax, JQuery, Html, CSS, Bootstrap, PostgreSQL, GitHub</h5>
                          <h5>Description: <ul>
                            <li> M3U file editor specifically for use with IPTV services. With Xtream, you can
                              create and sort your M3U playlist with an external link or a local M3U file</li>
                            <li> Role – Full Stack Developer</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Mimie Dubai (Mobile Application)
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Nodejs, MongoDb, ReactNative</h5>
                          <h5>Description: <ul>
                            <li> the app is more like a knowledge base meant to help people coming to
                              DUBAI.</li>
                            <li>In this Project created user authentication API, Image upload API,
                              Video Upload API, Offers API, Review API</li>
                            <li> Role – Backend Developer</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Ideadc (Django CMS)
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Python, Django, Ajax, JQuery, Html, CSS, Bootstrap, MySQL, Azure</h5>
                          <h5>Description: <ul>
                            <li> Ideadc is a service provider cloud computing product. Convert All pages
                              PHP to Django, all sites converted to Django CMS Pages, SSO Integration,
                              Auto Login with Fleio server.</li>

                            <li> Role – Full Stack Developer</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          AppMarketPlace
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Python, Django Rest-Framework,Reactjs, PostgreSQL,Gitlab,</h5>
                          <h5>Description: <ul>
                            <li> App Market place is online platform that list of apps , user can post their app,
                              an app marketplace app display multiple listing , and provide topical and
                              in-depth inform each app,</li>
                            <li>Two types user in marketplace User and Admin,Admin can approve and reject apps.</li>
                            <li> Role – Backend Developer</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-code" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Zevik-Quiz
                        </h2>
                        <p>
                          <h5>Tools & Technologies: Node Js, Express Js, TypeScript, TypeOrm, AdminBro, Aws</h5>
                          <h5>Description: <ul>
                            <li> 
                              User Authentication<br/>
                              Two type of user free and Unlimited<br/>
                              User buy plans(Paddle)<br/>
                              User set Game and auto generate quiz based of question types<br/>
                              Free user only play worksheet game<br/>
                              Unlimited user play both worksheets + Pirate game<br/>
                              AdminPanel<br/>
                              Url - (https://zevik.propeliustech.com/)</li>
                          </ul>
                          </h5>
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      // <div>
      //   <section className="colorlib-work" data-section="projects">
      //     <div className="colorlib-narrow-content">
      //       <div className="row">
      //         <div
      //           className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
      //           data-animate-effect="fadeInLeft"
      //         >
      //           <span className="heading-meta">My Work</span>
      //           <h2 className="colorlib-heading animate-box">Live Projects</h2>
      //         </div>
      //       </div>
      //       <div className="row">
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInLeft"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/project/EZ.png)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Ez-Shopper</a>
      //                 </h3>
      //                 <span>
      //                   <h2 style={{ color: "#ffffff" }}> ECommerce Website</h2>
      //                 </span>
      //                 <span>
      //                   <h3 style={{ color: "#ffffff" }}>
      //                     Frontend: Angular 9
      //                   </h3>
      //                   <h3 style={{ color: "#ffffff" }}>Backend: Firebase</h3>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInRight"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/project/Tallo.png)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Tallo Web App</a>
      //                 </h3>
      //                 <span>
      //                   <h1 style={{ color: "#ffffff" }}>
      //                     Business Event Managment
      //                   </h1>
      //                 </span>
      //                 <span className="info">
      //                   <h2 style={{ color: "#ffffff" }}>
      //                     Frontend: Angular 6
      //                   </h2>
      //                   <h3 style={{ color: "#ffffff" }}>Backend: Firebase</h3>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInTop"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/img-3.jpg)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Lifo</a>
      //                 </h3>
      //                 <span>
      //                   <h2 style={{ color: "#ffffff" }}>Ecommerce Website</h2>
      //                 </span>
      //                 <span className="info">
      //                   <h3>Frontend: Angular 10</h3>
      //                   <h3>Backend: Nodejs</h3>
      //                   <h3>Database: Postgress</h3>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInBottom"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/project/py.png)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Retool</a>
      //                 </h3>
      //                 <span className="info">
      //                   <h2 style={{ color: "#ffffff" }}>Python Script</h2>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInLeft"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/project/cupid.png)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Cupid Store</a>
      //                 </h3>
      //                 <span>
      //                   <h2 style={{ color: "#ffffff" }}>ECommerce Website</h2>
      //                 </span>
      //                 <span className="info">
      //                   <h3>Frontend: Django</h3>
      //                   <h3>Backend: Python</h3>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div
      //           className="col-md-4 animate-box"
      //           data-animate-effect="fadeInRight"
      //         >
      //           <div
      //             className="project"
      //             style={{ backgroundImage: "url(images/project/node.png)" }}
      //           >
      //             <div className="desc">
      //               <div className="con">
      //                 <h3>
      //                   <a href="!#">Csr Product</a>
      //                 </h3>
      //                 <span>
      //                   <h2 style={{ color: "#ffffff" }}>Nodejs Rest Api</h2>{" "}
      //                 </span>
      //                 <span className="info">
      //                   <h3>Backend: Nodejs</h3>
      //                 </span>
      //               </div>
      //             </div>
      //           </div>
      //         </div>

      //       </div>
      //       {/* <div className="row">
      //         <div className="col-md-12 animate-box">
      //           <p>
      //             <a href="!#" className="btn btn-primary btn-lg btn-load-more">
      //               Load more <i className="icon-reload" />
      //             </a>
      //           </p>
      //         </div>
      //       </div> */}
      //     </div>
      //   </section>
      // </div>
    );
  }
}
